import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { PersonPictureComponent } from './person-picture.component';
import { ActivityPersonToPersonPipe } from './pipe/activity-person-to-person.pipe';

@NgModule({
    imports: [
        CommonModule,
        IconFontModule
    ],
    exports: [
        PersonPictureComponent,
        ActivityPersonToPersonPipe
    ],
    declarations: [
        PersonPictureComponent,
        ActivityPersonToPersonPipe
    ]
})
export class PersonPictureModule { }
